// src/pages/RegistrationLei/RegistrationLei.tsx

import React, { useCallback, useEffect, useMemo, useState } from "react";
import Container from "../../components/ui/ui kit/Container";
import Button from "../../components/ui/ui kit/Button";
import { ReactComponent as NextIcon } from "../../assets/icons/home/createLei/next.svg";
import { ReactComponent as CancelIcon } from "../../assets/icons/home/createLei/cancel.svg";
import {
  RegistrationLeiPage,
  Title,
  Hr,
  TabName,
  NavLink,
} from "./style";
import Input from "../../components/ui/ui kit/Input";
import HintTooltip from "../../components/ui/HintTooltip";
import FlowStepper from "../../components/ui/FlowStepper";
import { useAuth } from "../../hooks/useAuth";
import { useAlert } from "../../hooks/useAlert";
import { useNavigate } from "react-router-dom";
import cl from "./RegisterLei.module.sass";
import { CreateLeiService} from "../../api/services/create-lei";
import { useDispatch } from "react-redux";
import { fetchDataForm } from "../../redux/action-creators/dataFormReducer";
// import BootstrapTable from "react-bootstrap-table-next";
import Loader from "../../components/ui/Loader";
import { AxiosResponse } from "axios";
import { $leiApi } from "../../api";
// Import Prices
import { calculateMultiYearPrice } from '../../components/functional/Prices/multiYearPrice';
import {
  calculateEntityTypeSurcharge,
  calculateLevel2Surcharge
} from '../../components/functional/Prices/surchargeUtils.js';
import { Helmet } from "react-helmet";

import {
  Card,
  CardContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { muiTheme } from "../../theme";


interface JurisdictionOption {
  value: string;
  label: string;
  surcharge: number;
  requiresState?: boolean;
}

const defaultCompanyDataPresearch = [{
  companyId: "",
  companyName: "",
  companyNumber: "",
  id: 0,
  legalJurisdiction: "",
}];

const defaultCompanyData = {
  company_name: "",
  company_number: "",
  entity_type: "",
  multi_year_support: 0,
  reporting_exception_reason: "",
  is_level_2_data_available: false,
};

const NON_PUBLIC_USE_CASES = [
  "Obstacles in the laws or regulations of a jurisdiction prevent the child Legal Entity from providing or publishing this information.",
  "The child Legal Entity reports that the consent of the parent was necessary under the applicable legal framework and the parent did not consent or could not be contacted.",
  "Binding legal commitments such as the articles governing the child Legal Entity, or a contract prevent the child Legal Entity from providing or publishing this information. This is distinct from laws or regulations of a jurisdiction that prevent the child Legal Entity from providing or publishing information on its parent.",
  "The child Legal Entity has sought to consult the parent entity about the reporting of the parent information to the Global LEI System but could not confirm the absence of detriment in a way that can appropriately prevent liability risks for the child Legal Entity (or those acting on its behalf) under the applicable legal framework. The disclosure of this information would be detrimental to the child Legal Entity or the relevant parent.",
  "The disclosure of this information would be detrimental to the Legal Entity or the relevant parent. This will include reasons generally accepted by public authorities in similar circumstances, based on a declaration by the entity.",
];

export class SearchLeiCode {
  static async getLeiCompany(name: string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records?filter[entity.names]=${encodeURIComponent(name)}`);
  }
}

export const RegistrationLei = () => {
  const isAuth = useAuth();
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));

  const [loading, setLoading] = useState<boolean>(false);

  // Jurisdictions - fetched live from RapidLEI (via the backend), not a
  // static bundled list, so a jurisdiction it stops supporting disappears
  // here too instead of staying selectable.
  const [jurisdictionCountries, setJurisdictionCountries] = useState<JurisdictionOption[]>([]);
  const [jurisdictionStates, setJurisdictionStates] = useState<Record<string, JurisdictionOption[]>>({});

  // States
  // Country select's own displayed value - kept separate from countryCode
  // (below), which doubles as the actual jurisdiction code sent to the
  // backend and gets overwritten with the state's code once a state is
  // chosen. Binding the select to countryCode directly made the country
  // name disappear from the field as soon as a state was picked, since
  // its value no longer matched any of the select's own options.
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [showStates, setShowStates] = useState(false);
  const [stateOptions, setStateOptions] = useState([] as JurisdictionOption[]); // Set initial state as an empty array
  // Company data stored in Session
  const [companyName, setCompanyName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [entityType, setEntityType] = useState("GENERAL");
  const [multiYearSupport, setMultiYearSupport] = useState(1);
  const [surchargePrice, setSurchargePrice] = useState(0);
  const [price, setPrice] = useState(0);
  const [isLevel2DataAvailable, setIsLevel2DataAvailable] = useState<boolean>(false);

  const [nextButtonEnabled, setNextButtonEnabled] = useState<boolean>(false);
  const [companyData, setCompanyData] = useState(defaultCompanyData);
  const [companyNameList, setCompanyNameList] = useState(defaultCompanyDataPresearch);
  const [presearchError, setPresearchError] = useState("");
  const [reportingExceptionReason, setReportingExceptionReason] = useState("");
  const navigate = useNavigate();
  const [/*companyStatus*/, setCompanyStatus] = React.useState("");

  const [Q1, setQ1] = React.useState("");
  const [Q2, setQ2] = React.useState("");
  const [Q3, setQ3] = React.useState("");
  const [Q4, setQ4] = React.useState("");
  const [npUseCaseConfirmed, setNpUseCaseConfirmed] = React.useState(false);

  const [isSearchClicked, setIsSearchClicked] = useState(false);

  let multiYearPrice = calculateMultiYearPrice(multiYearSupport);
  let entityTypeSurcharge = calculateEntityTypeSurcharge(entityType);
  let level2Surcharge = calculateLevel2Surcharge(isLevel2DataAvailable);

  const [manualCompanyName, setManualCompanyName] = useState('');
  const [manualCompanyNumber, setManualCompanyNumber] = useState('');
  const [showManualEntry, setShowManualEntry] = useState(false);


  const handlePresearch = () => {
    const company_data = {
      "company_name": companyName,
      "country_code": countryCode,
    }
  
    if (companyName === "" && countryCode === "") {
      showAlert("Please enter a Company Name or a Company Number, and choose the Country. If you require an LEI for a Fund or similar category please select the required Entity Type.");
      setIsSearchClicked(false);
    } else if (companyName !== "" && countryCode === "") {
      showAlert("Please choose the Country. If you require an LEI for a Fund or similar category please select the required Entity Type.");
      setIsSearchClicked(false);
    } else if (
      companyName !== "" &&
      showStates &&
      selectedState === ""
    ) {
      showAlert("Please choose the State as well. If you require an LEI for a Fund or similar category please select the required Entity Type.");
      setIsSearchClicked(false);
    } else if (companyName === "" && countryCode !== "") {
      showAlert("Please enter a Company Name. If you require an LEI for a Fund or similar category please select the required Entity Type.");
      setIsSearchClicked(false);
    } else {
      setIsSearchClicked(true);
      requestCompanyNameList(company_data);
    }
  };

  //*********** States *************
  const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCountry = event.target.value;
    setSelectedCountry(selectedCountry);
    setCountryCode(selectedCountry);

    const countryMeta = jurisdictionCountries.find(c => c.value === selectedCountry);
    if (countryMeta?.requiresState) {
      setShowStates(true);
      setStateOptions(jurisdictionStates[selectedCountry] || []);
      setSelectedState('');
    } else {
      setShowStates(false);
      setSelectedState('');
    }
  };

  const handleStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedState = event.target.value;
    // setSelectedCountry(selectedCountry);
    setSelectedState(selectedState);
    setCountryCode(selectedState); 
  };

  //*********** States End *************
  
  const requestCountries = useCallback(async () => {
    try {
      const res = await CreateLeiService.requestCountries();
      const data = res.data.data;

      setJurisdictionCountries(
        data.countries.map((c: any): JurisdictionOption => ({
          value: c.code,
          label: `${c.label} (${c.code})`,
          surcharge: c.surcharge,
          requiresState: c.requires_state,
        }))
      );

      const statesMap: Record<string, JurisdictionOption[]> = {};
      Object.entries(data.states).forEach(([prefix, options]) => {
        statesMap[prefix] = (options as any[]).map((s: any): JurisdictionOption => ({
          value: s.code,
          label: `${s.label} (${s.code})`,
          surcharge: s.surcharge,
        }));
      });
      setJurisdictionStates(statesMap);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const requestCompanyNameList = useCallback(async (
    companyDataPresearch: {
      company_name: string,
      country_code: string
    }
  ) => {
    try {
      setCompanyNameList([]);
      setCompanyData(defaultCompanyData);
      setPresearchError("");
      setLoading(true);
      const res = await CreateLeiService.preSearch(companyDataPresearch);
      setCompanyNameList(res.data.data);
      // console.log(res.data.data);

    } catch (error: any) {
      console.log('-> ERROR in requestCompanyNameList:', error);
      setPresearchError(
        error?.response?.data?.message || "Something went wrong while searching. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }, []);

  //Scroll to top
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleOnQ1Change = (q1Value: any) => {
    if (Q1 !== q1Value) {
      setQ1(q1Value);
      setQ2("");
      setQ3("");
      setQ4("");
      setIsLevel2DataAvailable(false);
      setReportingExceptionReason(q1Value === "yes" ? "NATURAL_PERSONS" : "");
      setNpUseCaseConfirmed(false);
    }
  }

  const handleOnQ2Change = (q2Value: any) => {
    if (Q2 !== q2Value) {
      setQ2(q2Value);
      setQ3("");
      setQ4("");
      setIsLevel2DataAvailable(false);
      setReportingExceptionReason(q2Value === "no" ? "NO_KNOWN_PERSON" : "");
      setNpUseCaseConfirmed(false);
    }
  }

  const handleOnQ3Change = (q3Value: any) => {
    if (Q3 !== q3Value) {
      setQ3(q3Value);
      setQ4("");
      setIsLevel2DataAvailable(false);
      setReportingExceptionReason(q3Value === "no" ? "NON_CONSOLIDATING" : "");
      setNpUseCaseConfirmed(false);
    }
  }

  const handleOnQ4Change = (q4Value: any) => {
    if (Q4 !== q4Value) {
      setQ4(q4Value);
      setIsLevel2DataAvailable(q4Value === "yes");
      console.log("q4Value:", q4Value, q4Value === "yes");
      setReportingExceptionReason(q4Value === "no" ? "NON_PUBLIC" : "");
      setNpUseCaseConfirmed(false);
    }
  }

  const l2Message = useMemo(() => {
    if (reportingExceptionReason === "" && isLevel2DataAvailable) {
      return "You need to provide Level 2 Data for this entity. Don't worry, once you have placed an order, we will contact you to clarify the details of the ownership structure. The fee (€30) for Level 2 Data processing will be added to your order.";
    } else if (reportingExceptionReason === "NON_PUBLIC") {
      return "Both your Direct and Ultimate Parent Information will have NON_PUBLIC as the exception reason. Use this NON_PUBLIC exception reason ONLY if one of the following use cases applies to the Legal Entity!";
    } else {
      return "";
    }
  }, [isLevel2DataAvailable, reportingExceptionReason]);

  useEffect(() => {
    requestCountries();
  }, [requestCountries]);

  useEffect(() => {
    let updatedPrice: number
    let updatedSurchargePrice: number

    if (showStates) {
      const selectedState = stateOptions.find(state => state.value === countryCode);
      updatedPrice = selectedState
        ? multiYearSupport * (selectedState.surcharge + multiYearPrice + entityTypeSurcharge + level2Surcharge)
        : 0;
      updatedSurchargePrice = selectedState ? multiYearSupport * selectedState.surcharge: 0;
      setSurchargePrice(updatedSurchargePrice);
      setPrice(updatedPrice);
    } else {
      const selectedCountryMeta = jurisdictionCountries.find(country => country.value === countryCode);
      updatedPrice = selectedCountryMeta
        ? multiYearSupport * (selectedCountryMeta.surcharge + multiYearPrice + entityTypeSurcharge + level2Surcharge)
        : 0;
      updatedSurchargePrice = selectedCountryMeta
        ? multiYearSupport * selectedCountryMeta.surcharge
        : 0;
      setSurchargePrice(updatedSurchargePrice);
      setPrice(updatedPrice);
    }

    console.log('---> price:', updatedPrice);

    setCompanyData(companyData => ({
      ...companyData,
      multi_year_support: multiYearSupport,
      reporting_exception_reason: reportingExceptionReason,
      entity_type: entityType,
      price: updatedPrice,
      multi_year_price: multiYearPrice,
      entity_type_surcharge: entityTypeSurcharge,
      level2_surcharge: level2Surcharge,
      surcharge_price: updatedSurchargePrice,
      is_level_2_data_available: isLevel2DataAvailable,
    }));
  }, [
    countryCode, entityType, entityTypeSurcharge, isLevel2DataAvailable, level2Surcharge,
    multiYearPrice, multiYearSupport, reportingExceptionReason,
    showStates, stateOptions, jurisdictionCountries,
  ]);

  useEffect(() => {
    if (
      "company_name" in companyData
      && "company_number" in companyData
      && "entity_type" in companyData
      && "multi_year_support" in companyData
      && ("reporting_exception_reason" in companyData || isLevel2DataAvailable)
    ) {
      if (
        companyData["company_name"]
        && companyData["company_number"] !== "-"
        && companyData["entity_type"] !== "-"
        && companyData["multi_year_support"]
        && (companyData["reporting_exception_reason"] || isLevel2DataAvailable)
        && (companyData["reporting_exception_reason"] !== "NON_PUBLIC" || npUseCaseConfirmed)
      ) {
        setNextButtonEnabled(true);
        console.log("true");
      } else {
        setNextButtonEnabled(false);
      }
    } else {
      setNextButtonEnabled(false);
    }
    console.log("companyData", companyData)
  }, [companyData, isLevel2DataAvailable, npUseCaseConfirmed]);

  const checkCompany = async (row: any) => {
    const [resGleif, resAPI] = await Promise.all([
      SearchLeiCode.getLeiCompany(row["companyName"]),
      CreateLeiService.orderSubmitStatus({
        order_type: 'Registration',
        company_name: row['companyName'],
        company_number: row['companyNumber'],
        legal_jurisdiction: countryCode
      })
    ])

    const submitStatus = resAPI.data.data['status'];
    if (resGleif.data.data.length > 0 || submitStatus !== 'NO_ACTIVE_ORDERS') {
      const existingCompanyName = row["companyName"];
      const alertMessage = resGleif.data.data.length > 0 || submitStatus === 'ALREADY_REGISTERED'
        ? `LEI already exists for company '${existingCompanyName}', please select another company.`
        : `There are active orders for company '${existingCompanyName}', please select another company.`;;      
      showAlert(alertMessage);
      setCompanyStatus(alertMessage);
      const data = {
        company_name: "",
        company_number: "-",
        entity_type: entityType,
        multi_year_support: multiYearSupport,
        reporting_exception_reason: reportingExceptionReason,
        is_level_2_data_available: Boolean(companyData["is_level_2_data_available"]),
      };
      setCompanyData(data);
    } else {
      const data = {
        company_name: row["companyName"],
        company_number: row["companyNumber"],
        entity_type: entityType,
        multi_year_support: companyData["multi_year_support"],
        reporting_exception_reason: companyData["reporting_exception_reason"],
        is_level_2_data_available: Boolean(companyData["is_level_2_data_available"]),
      };
      setCompanyData(data);
      setCompanyNameList([{
        ...row,
        id: row.id + "s",
      }]);
      setCompanyStatus("");
      // The list collapses down to just the selected row and the rest of
      // the form appears below it - if the user picked a company from the
      // bottom of a long list, they'd otherwise stay scrolled down with no
      // indication anything happened.
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const isCompanyRowSelected = (row: any) => {
    if (companyData && companyData['company_name'] && companyData['company_number']) {
      return companyData['company_name'] === row['companyName'] &&
        companyData['company_number'] === row['companyNumber'];
    }
    return false;
  };

  const renderSelectButton = (row: any) => {
    const isRowSelected = isCompanyRowSelected(row);
    return (
      <Button
        styleType="primary"
        onClick={() => checkCompany(row)}
        disabled={isRowSelected}
        width="80px"
        height="34px"
        noMarginTop
      >
        {isRowSelected ? 'Selected' : 'Select'}
      </Button>
    );
  };

  const handleNext = async () => {
    const data = companyData;
    setLoading(true);
    const preparedData = {
      ...data,
      legal_jurisdiction: countryCode,
      order_type: 'Registration'
    };
    console.log("data", preparedData);
    await dispatch(fetchDataForm(preparedData))

    navigate('/relationship', 
    {
      // state: {
      //   companyName: companyData["company_name"],
      //   companyNumber: companyData["company_number"],
      //   entityType: entityType,
      //   countryCode: countryCode,
      //   multiYearPrice: multiYearPrice,
      //   multiYearSupport: companyData["multi_year_support"],
      //   surchargePrice: surchargePrice,
      //   entityTypeSurcharge: entityTypeSurcharge,
      //   level2Surcharge: level2Surcharge,
      //   price: price,
      // },
    });
  };

  const isCompanySelected = useMemo(() => {
    return !loading && isSearchClicked && companyData && companyData.company_name;
  }, [companyData, isSearchClicked, loading]);

  return (
    <Container>
        <Helmet> {/* don't forget: import { Helmet } from "react-helmet"; */}
        <title>LEI Registration – Entity data</title>
        <meta 
          name="description" 
          content="LEI Registration Process – Entity data. LEIpapa is an official LEI Registration Agent of Ubisecure RapidLEI. Press Create LEI Application to Register, Renew or Transfer an LEI." 
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {isAuth && (
        <RegistrationLeiPage>
          <div className={cl["container_big"]}>
            <FlowStepper activeStep={0} flowName="Registration" />
            <div className={cl["title_wrap"]}>
              <Title>Entity data</Title>
            </div>

            <TabName className={cl["tab_name"]}>
              First, let's locate the details of your Company, Legal Entity or Fund <HintTooltip text="Please enter the officially registered Legal Entity name for your company (or the company number), the jurisdiction of incorporation, and the Entity type." />
            </TabName>
            <div className={cl["card_body"]}>
              <div className={cl["input_wrap"]}>
                <div>
                  <Input
                    placeholder="Registered Company Name or Number"
                    uiProps={{width: "100%", margin: "0px"}}
                    {...{
                      onChange:(data) => 
                      setCompanyName(data.target.value),
                    }}
                    isRequired
                  />
                </div>
                <div>
                  <Input
                    type="select"
                    searchable
                    id="country"
                    placeholder="Country"
                    uiProps={{width: "100%", margin: "0px"}}
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    options={jurisdictionCountries}
                    isRequired
                  />

                  {showStates && (
                    <Input
                      type="select"
                      searchable
                      id="state"
                      placeholder="State"
                      uiProps={{width: "100%", margin: "16px 0px 0px"}}
                      value={selectedState}
                      onChange={handleStateChange}
                      options={stateOptions}
                      isRequired
                    />
                  )}
                </div>
                <div>
                  <Input
                    type="select"
                    id="entitytype"
                    placeholder="Entity Type"
                    uiProps={{width: "100%", margin: "0px"}}
                    value={entityType}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => setEntityType(event.target.value)}
                    options={["GENERAL", "SOLE_PROPRIETOR", "FUND", "WILL_PENSION", "TRUST", "OTHER"]}
                  />
                </div>
                <Button styleType="primary" onClick={handlePresearch} height="40px" noMarginTop>
                  Search
                </Button>
              </div>

              {isSearchClicked &&
                (
                  <>
                    <div className={cl["table_wrap"]}>
                      {loading ? <Loader /> : ""}
                      {companyNameList.length > 0 && (
                        isMobile ? (
                          <Stack spacing={1.5}>
                            {companyNameList.map((row: any, index: number) => (
                              <Card key={row.id ?? index} variant="outlined">
                                <CardContent>
                                  <Typography variant="subtitle1" fontWeight={600}>
                                    {row.companyName}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                    Company Number: {row.companyNumber}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    Country: {row.legalJurisdiction}
                                  </Typography>
                                  <Stack sx={{ mt: 1.5 }}>
                                    {renderSelectButton(row)}
                                  </Stack>
                                </CardContent>
                              </Card>
                            ))}
                          </Stack>
                        ) : (
                          <TableContainer>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Legal Name</TableCell>
                                  <TableCell align="center">Company Number</TableCell>
                                  <TableCell align="center">Country</TableCell>
                                  <TableCell />
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {companyNameList.map((row: any, index: number) => (
                                  <TableRow key={row.id ?? index} hover>
                                    <TableCell>{row.companyName}</TableCell>
                                    <TableCell align="center">{row.companyNumber}</TableCell>
                                    <TableCell align="center">{row.legalJurisdiction}</TableCell>
                                    <TableCell align="right">{renderSelectButton(row)}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )
                      )}
                      {!isCompanySelected && !loading && (
                        <div className={cl["px-25"]}>
                          <p style={{ marginTop: "1.5rem", lineHeight: "1.5", textAlign: "justify" }}>The search results are provided for the {countryCode} jurisdiction.</p>
                          <p style={{ marginTop: "1.5rem", marginBottom: "1.5rem", lineHeight: "1.5", textAlign: "justify" }}>Not the results you expected? If your Company Name consists of more than one word, try writing the full Company Name for a more accurate query.</p>
                        </div>
                      )}
                      {!loading && presearchError && (
                        <div className={cl["px-25"]}>
                          <p style={{ fontWeight: "bold", color: "#E8464E", lineHeight: "1.5", textAlign: "justify" }}>{presearchError}</p>
                        </div>
                      )}
                      {!loading && !presearchError && companyNameList.length === 0 && (
                        <div>
                          <div className={cl["px-25"]}>
                            <p style={{ fontWeight: "bold", lineHeight: "1.5", textAlign: "justify" }}>No companies that meet the search criteria.</p>
                            <p style={{ marginTop: "1.5rem", lineHeight: "1.5", textAlign: "justify" }}>You can manually enter the details to proceed:</p>
                          </div>
                          <div className={cl["input_wrap_manual"]}>
                            <Input
                              type="text"
                              placeholder="Company Name"
                              value={manualCompanyName}
                              onChange={e => setManualCompanyName(e.target.value)}
                              isRequired
                            />
                            <Input
                              type="text"
                              placeholder="Company Number"
                              value={manualCompanyNumber}
                              onChange={e => setManualCompanyNumber(e.target.value)}
                              isRequired
                            />
                            <Button
                              styleType="primary"
                              onClick={() => {
                                if (manualCompanyName && manualCompanyNumber) {
                                  setCompanyData({
                                    ...companyData,
                                    company_name: manualCompanyName,
                                    company_number: manualCompanyNumber
                                  });
                                  setShowManualEntry(false);
                                } else {
                                  showAlert('Please fill in both fields to proceed.');
                                }
                              }}
                              disabled={!!isCompanySelected}
                              width="80px"
                              height="34px"
                              noMarginTop
                            >
                              {isCompanySelected ? 'Selected' : 'Select'}
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* {!isCompanySelected && !loading && (
                      <div className={cl["wrap_l2"]}>
                        <p style={{ lineHeight: "1.5" }}>The search results are provided for the {countryCode} jurisdiction.</p><br />
                        <p style={{ lineHeight: "1.5" }}>Not the results you expected? If your Company Name consists of more than one word, try writing the full Company Name for a more accurate query.
                        If the Company still does not appear, click <a href="https://tally.so/r/n0eX9A" title="Register an LEI manually">HERE</a> to manually fill in the data.</p>
                      </div>
                    )} */}

                    {isCompanySelected && (
                      <>
                        <div className={cl["input_wrap_years"]}>
                          <div>
                            <Input
                              type="select"
                              id="multiyearsupport"
                              placeholder="Year to support"
                              uiProps={{width: "100%", margin: "0px"}}
                              value={multiYearSupport}
                              onChange={(event: React.ChangeEvent<HTMLInputElement>) => setMultiYearSupport(Number(event.target.value))}
                              options={["1", "2", "3", "4", "5"]}
                            />
                          </div>
                        </div>
    
                        <div className={cl["wrap_l2"]}>
                          <div className={cl["Q"]}>
                            <p>{"Is the Legal Entity controlled by only Private Individuals (Natural Persons)?"}</p>
                            <Button styleType={Q1 === "yes" ? "primary" : "outlined"} onClick={() => handleOnQ1Change("yes")} width="80px" height="34px" noMarginTop>Yes</Button>
                            <Button styleType={Q1 === "no" ? "primary" : "outlined"} onClick={() => handleOnQ1Change("no")} width="80px" height="34px" noMarginTop sx={{ ml: 1 }}>No</Button>
                          </div>
                          {Q1 === "no" && (
                            <div className={cl["Q"]}>
                              <p>{"Is the Legal Entity owned by another legal entity? (Controlling share, typically > 50% shareholding)"}</p>
                              <Button styleType={Q2 === "yes" ? "primary" : "outlined"} onClick={() => handleOnQ2Change("yes")} width="80px" height="34px" noMarginTop>Yes</Button>
                              <Button styleType={Q2 === "no" ? "primary" : "outlined"} onClick={() => handleOnQ2Change("no")} width="80px" height="34px" noMarginTop sx={{ ml: 1 }}>No</Button>
                            </div>
                          )}
                          {(Q2 === "yes") && (
                            <div className={cl["Q"]}>
                              <p>{"Does the Legal Entity consolidate financial statements into the controlling legal entity?"}</p>
                              <Button styleType={Q3 === "yes" ? "primary" : "outlined"} onClick={() => handleOnQ3Change("yes")} width="80px" height="34px" noMarginTop>Yes</Button>
                              <Button styleType={Q3 === "no" ? "primary" : "outlined"} onClick={() => handleOnQ3Change("no")} width="80px" height="34px" noMarginTop sx={{ ml: 1 }}>No</Button>
                            </div>
                          )}
                          {(Q3 === "yes") && (
                            <div className={cl["Q"]}>
                              <p>
                                Are you able to make the Parental information for either your&nbsp;
                                <a
                                  href="https://www.gleif.org/en/lei-data/access-and-use-lei-data/level-2-data-who-owns-whom"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  Direct or Ultimate Parent
                                </a>&nbsp;Public?&nbsp;
                                <HintTooltip text="Any company where your accounts are directly consolidated is known as your Direct Parent. A higher-level company that consolidates the accounts for the group would be an Ultimate Parent. (Note that they can be the same legal entity)" />
                              </p>
                              <Button styleType={Q4 === "yes" ? "primary" : "outlined"} onClick={() => handleOnQ4Change("yes")} width="80px" height="34px" noMarginTop>Yes</Button>
                              <Button styleType={Q4 === "no" ? "primary" : "outlined"} onClick={() => handleOnQ4Change("no")} width="80px" height="34px" noMarginTop sx={{ ml: 1 }}>No</Button>
                            </div>
                          )}
                          {l2Message && <div className={cl["l2_message"]}>{l2Message}</div>}
                          {reportingExceptionReason === "NON_PUBLIC" && (
                            <div className={cl["use-case-checkbox-wrapper"]}>
                              <Input
                                type="checkbox"
                                id="use-case-confirmed"
                                name="useCaseConfirmed"
                                checked={npUseCaseConfirmed}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                  setNpUseCaseConfirmed(e.target.checked);
                                }}
                              />
                              <p><span style={{fontWeight: 'bold'}}>I confirm that at least one of the below cases is applicable to the Legal Entity I am applying for, and that is the reason for choosing the NON_PUBLIC exception reason.</span></p>
                            </div>
                          )}
                          {reportingExceptionReason === "NON_PUBLIC" && (
                            <ul className={cl["use-cases-wrapper"]}>
                              {NON_PUBLIC_USE_CASES.map((item, index) => (
                                <li key={`use-case-${index}`}>
                                  { item }
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
    
                        <Hr />
                        <div className={cl["wrap_l2_right"]}>
                          <div className={cl["price_text"]}>Order calculation</div>
                          <p>Years to support: {multiYearSupport}</p>
                          <p>Base price: €{multiYearPrice} x {multiYearSupport} = {multiYearPrice * multiYearSupport}</p>
                          {surchargePrice > 0 && (
                            <p>Jurisdictional surcharge: €{surchargePrice/multiYearSupport} x {multiYearSupport} = {surchargePrice}</p>
                          )}
                          {entityTypeSurcharge > 0 && (
                            <p>Entity type surcharge: €{entityTypeSurcharge} x {multiYearSupport} = {entityTypeSurcharge * multiYearSupport}</p>
                          )}
                          {level2Surcharge > 0 && (
                            <p>Level 2 surcharge: €{level2Surcharge} x {multiYearSupport} = {level2Surcharge * multiYearSupport}</p>
                          )}
                          <p>Total: €{price}</p>
                          {/* <p>Total: €{multiYearPrice * multiYearSupport + surchargePrice + entityTypeSurcharge + level2Surcharge}</p> */}
                          {/* <span className={cl["price_text"]}>Level 2 surcharge: €{level2Surcharge}</span> */}
                        </div>
                      </>
                    )}
                  </>
                )
              }
            </div>
            <div className={cl["title_inner-button"]}>
              <Button
                styleType="danger"
                component={NavLink}
                to="/"
                startIcon={<CancelIcon />}
                width="auto"
                noMarginTop
              >
                Cancel
              </Button>

              <Button
                styleType="primary"
                onClick={handleNext}
                disabled={!nextButtonEnabled}
                startIcon={<NextIcon />}
                width="auto"
                noMarginTop
              >
                Next
              </Button>
            </div>
          </div>
        </RegistrationLeiPage>
      )}
    </Container>
  );
};
